var map = {
	"./01_Mittel.png": 6015,
	"./02_ArtSerf.png": 2949,
	"./03_Lamec.png": 3836,
	"./04_irinox.png": 5842,
	"./05_SerenaWines.png": 6158,
	"./06_Slec.png": 3888,
	"./07_Paxion.png": 7824,
	"./08_StudioMatce.png": 7641,
	"./09_Dema.png": 6888,
	"./10_Seripiave.png": 2402,
	"./11_Savno.png": 9811,
	"./12_Ops.png": 7538,
	"./13_Origama.png": 8334,
	"./14_Abs.png": 6800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7220;